import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "IntervalType/";

const getIntervalTypeById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetIntervalTypeById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getIntervalTypes = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetIntervalTypes', constants.REQUIRE_INTERCEPTORS);

const saveIntervalType = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveIntervalType', model, constants.REQUIRE_INTERCEPTORS);

const deleteIntervalType = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteIntervalType?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getIntervalTypeById,
    getIntervalTypes,
    saveIntervalType,
    deleteIntervalType
}